// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tab-bar[data-v-08424486]{background-color:#fff!important;margin:10px 0;padding:12px 20px 0}.tab-bar .layer[data-v-08424486]{position:relative}.tab-bar .layer .el-button[data-v-08424486]{position:absolute;right:10px;top:5px}.tab-bar .layer .el-button .rotate[data-v-08424486]{transform:rotate(1turn);transition:all 1s}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
